"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));
/* eslint-disable */


var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "38",
    height: "38",
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    style: {
      mixBlendMode: 'luminosity'
    }
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50658 29.4934 0 19 0C8.50659 0 0 8.50658 0 19C0 29.4934 8.50659 38 19 38Z",
    fill: "#FFDE63"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0417 15.0416C34.0417 25.535 25.5351 34.0416 15.0417 34.0416C10.8047 34.0416 6.89154 32.6547 3.73157 30.31C7.19359 34.976 12.7437 37.9999 19 37.9999C29.4935 37.9999 38 29.4933 38 18.9999C38 12.7436 34.9762 7.19346 30.3102 3.73145C32.6548 6.89142 34.0417 10.8045 34.0417 15.0416Z",
    fill: "#FFD13E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.4896 19.7917C13.6595 19.7917 16.2292 17.222 16.2292 14.0521C16.2292 10.8822 13.6595 8.3125 10.4896 8.3125C7.3197 8.3125 4.75 10.8822 4.75 14.0521C4.75 17.222 7.3197 19.7917 10.4896 19.7917Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.5105 19.7917C30.6803 19.7917 33.2501 17.222 33.2501 14.0521C33.2501 10.8822 30.6803 8.3125 27.5105 8.3125C24.3406 8.3125 21.7709 10.8822 21.7709 14.0521C21.7709 17.222 24.3406 19.7917 27.5105 19.7917Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.4896 15.8333C11.4734 15.8333 12.2709 15.0358 12.2709 14.052C12.2709 13.0682 11.4734 12.2708 10.4896 12.2708C9.50587 12.2708 8.70837 13.0682 8.70837 14.052C8.70837 15.0358 9.50587 15.8333 10.4896 15.8333Z",
    fill: "#262626"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.5104 15.8333C28.4941 15.8333 29.2916 15.0358 29.2916 14.052C29.2916 13.0682 28.4941 12.2708 27.5104 12.2708C26.5266 12.2708 25.7291 13.0682 25.7291 14.052C25.7291 15.0358 26.5266 15.8333 27.5104 15.8333Z",
    fill: "#262626"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.53125 18.2083C7.56495 19.1807 8.95163 19.7916 10.4896 19.7916C12.0275 19.7916 13.4268 19.1932 14.4479 18.2083H6.53125Z",
    fill: "#50DCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.5521 18.2083C24.5858 19.1807 25.9725 19.7916 27.5105 19.7916C29.0484 19.7916 30.4477 19.1932 31.4688 18.2083H23.5521Z",
    fill: "#50DCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2384 27.0134C14.3091 25.3947 16.5651 24.2858 19.178 24.2858C21.7909 24.2858 24.0469 25.3947 25.1175 27.0134C25.1176 27.0134 26.0735 28.441 27.0294 27.0134C25.997 24.5535 22.8743 22.7563 19.178 22.7563C15.4817 22.7563 12.359 24.5535 11.3266 27.0134L11.3265 27.0134C12.2825 28.441 13.2384 27.0134 13.2384 27.0134L13.2384 27.0134Z",
    fill: "black"
  })));
};

exports.default = _default;